import { createDeliveryRoute, type DeliveryRoute } from '../Delivery/shared';

/**
 * Sub-routes for the standalone `/shipping` page. Same delivery flow as
 * `/my-packs`, only rooted at `/shipping` — produced by the shared
 * `createDeliveryRoute` factory.
 *
 *   /shipping                       → { kind: 'index' }        — deliveries list
 *   /shipping/deliveries/new        → { kind: 'delivery-new' } — create form
 *   /shipping/deliveries/:id        → { kind: 'delivery-show', id }
 */
export type ShippingRoute = DeliveryRoute;

const router = createDeliveryRoute('/shipping');

export const useShippingRoute = router.useRoute;
